import { NavigationExtras } from '@angular/router';

type UnifiedRoute = string | string[];
type UnifiedRouteOpts = { replace ?:boolean; state ?:any };

/**
 * A generic wrapper for routing, allowing us to control the router's interface.
 *
 * This will also allow for interoperation of multiple routers to facilitate
 * microservices, should the need arise.
 */
class UnifiedRouter {
  private angularCallback :(commands :any[], extras ?:NavigationExtras) => void;

  setAngularCallback(
    callback :(commands :any[], extras ?:NavigationExtras) => void,
  ) {
    this.angularCallback = callback;
  }

  navigate(route :UnifiedRoute, opts :UnifiedRouteOpts = { replace: false }) {
    this.angularCallback(Array.isArray(route) ? route : [route], {
      replaceUrl: opts.replace,
    });
  }
}

/** @var {Router} */
export const router = new UnifiedRouter();
